<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select  class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="452"> </caass-schoolselector>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Date Option</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="DateOptionID" [(ngModel)]="report.DateOptionID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of DateOptionList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group" *ngIf="report.DateOptionID == -1">
						<label class="col-sm-3 col-lg-2 control-label">Start Date</label>

						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.startDate" name="txtStartDate"></p-calendar>
						</div>
					</div>

					<div class="form-group" *ngIf="report.DateOptionID == -1">
						<label class="col-sm-3 col-lg-2 control-label">End Date</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="report.endDate" name="txtEndDate"></p-calendar>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Filter Time</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="TimeOptionID" [(ngModel)]="report.TimeOptionID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of TimeOptionList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group" *ngIf="report.TimeOptionID == 1">
						<label class="col-sm-3 col-lg-2 control-label">Start Time</label>

						<div class="col-sm-4 col-lg-3">
							<p-calendar
								showIcon="true"
								showButtonBar="true"
								[timeOnly]="true"
								hourFormat="12"
								[(ngModel)]="report.StartTime"
								name="StartTime"
							></p-calendar>
						</div>
					</div>

					<div class="form-group" *ngIf="report.TimeOptionID == 1">
						<label class="col-sm-3 col-lg-2 control-label">End Time</label>
						<div class="col-sm-4 col-lg-3">
							<p-calendar
								showIcon="true"
								showButtonBar="true"
								[timeOnly]="true"
								hourFormat="12"
								[(ngModel)]="report.EndTime"
								name="EndTime"
							></p-calendar>
						</div>
					</div>

					<div class="form-group" *ngIf="report.TimeOptionID == 2">
						<label class="col-sm-3 col-lg-2 control-label">Period</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="PeriodID" [(ngModel)]="report.PeriodID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of PeriodList" [ngValue]="o.PeriodID">
									{{ o.PeriodDesc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort By</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortBy" [(ngModel)]="report.SortBy">
								<option *ngFor="let o of SortByList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Sort Direction</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SortDirection" [(ngModel)]="report.SortDirection">
								<option *ngFor="let o of SortDirectionList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
